import axios from 'axios';

const MIGO_API_URL = 'https://api.migo.pe/api/v1';
const MIGO_TOKEN = 'oxzdu4ZBlghIaetvqYux8CocEVJABQAkptMBcpUyQVhXr5sF3vb0ABZxJF40';

/**
 * Consultar información de RUC desde la API de Migo
 * @param {string} ruc - RUC a consultar (11 dígitos)
 * @returns {Promise<Object>} - Objeto con la información del RUC
 */
export const consultRUC = async (ruc) => {
  try {
    console.log('📡 [migoService] Consultando RUC:', ruc);
    
    const response = await axios.post(
      `${MIGO_API_URL}/ruc`,
      {
        token: MIGO_TOKEN,
        ruc: ruc
      },
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('✅ [migoService] Respuesta RUC recibida:', response.data);
    console.log('📋 [migoService] Tipo de respuesta:', typeof response.data);
    console.log('📋 [migoService] Estructura completa:', JSON.stringify(response.data, null, 2));
    
    // Extraer solo los campos que necesitamos
    // La API de Migo puede devolver diferentes estructuras, intentamos todas las posibles
    const data = response.data;
    
    // Verificar si la respuesta tiene una estructura anidada
    console.log('🔍 [migoService] Verificando estructura de datos...');
    console.log('🔍 [migoService] data.nombre_o_razon_social:', data.nombre_o_razon_social);
    console.log('🔍 [migoService] data.razon_social:', data.razon_social);
    console.log('🔍 [migoService] data.nombre:', data.nombre);
    console.log('🔍 [migoService] Todas las claves del objeto:', Object.keys(data));
    
    // Intentar extraer el nombre de todas las posibles propiedades
    // Verificar todas las posibles variantes del campo nombre
    let name = '';
    if (data.nombre_o_razon_social && data.nombre_o_razon_social.trim() !== '') {
      name = data.nombre_o_razon_social;
    } else if (data.razon_social && data.razon_social.trim() !== '') {
      name = data.razon_social;
    } else if (data.nombre && data.nombre.trim() !== '') {
      name = data.nombre;
    } else if (data.nombre_comercial && data.nombre_comercial.trim() !== '') {
      name = data.nombre_comercial;
    } else if (data.razonSocial && data.razonSocial.trim() !== '') {
      name = data.razonSocial;
    } else if (data.razon_social_completa && data.razon_social_completa.trim() !== '') {
      name = data.razon_social_completa;
    }
    
    console.log('🔍 [migoService] Campo nombre_o_razon_social encontrado:', data.nombre_o_razon_social);
    console.log('🔍 [migoService] Nombre extraído:', name);
    
    // Intentar extraer la dirección de todas las posibles propiedades
    // Si la dirección es solo un guión o está vacía, intentar construirla desde otros campos
    let address = '';
    if (data.direccion && data.direccion.trim() !== '-' && data.direccion.trim() !== '') {
      address = data.direccion;
    } else if (data.direccion_completa && data.direccion_completa.trim() !== '-' && data.direccion_completa.trim() !== '') {
      address = data.direccion_completa;
    } else if (data.direccionCompleta && data.direccionCompleta.trim() !== '-' && data.direccionCompleta.trim() !== '') {
      address = data.direccionCompleta;
    } else if (data.domicilio_fiscal && data.domicilio_fiscal.trim() !== '-' && data.domicilio_fiscal.trim() !== '') {
      address = data.domicilio_fiscal;
    } else if (data.direccion_fiscal && data.direccion_fiscal.trim() !== '-' && data.direccion_fiscal.trim() !== '') {
      address = data.direccion_fiscal;
    } else if (data.direccion_simple && data.direccion_simple.trim() !== '-' && data.direccion_simple.trim() !== '') {
      address = data.direccion_simple;
    } else {
      // Intentar construir la dirección desde campos individuales
      const addressParts = [];
      if (data.tipo_de_via && data.tipo_de_via.trim() !== '-') addressParts.push(data.tipo_de_via);
      if (data.nombre_de_via && data.nombre_de_via.trim() !== '-') addressParts.push(data.nombre_de_via);
      if (data.numero && data.numero.trim() !== '-') addressParts.push(data.numero);
      if (data.distrito && data.distrito.trim() !== '-') addressParts.push(data.distrito);
      if (data.provincia && data.provincia.trim() !== '-') addressParts.push(data.provincia);
      if (data.departamento && data.departamento.trim() !== '-') addressParts.push(data.departamento);
      
      if (addressParts.length > 0) {
        address = addressParts.join(', ');
      }
    }
    
    const result = {
      success: true,
      data: {
        ruc: data.ruc || data.numero_documento || ruc,
        name: name.trim(),
        address: address.trim(),
      }
    };
    
    console.log('📤 [migoService] Datos procesados:', result);
    return result;
  } catch (error) {
    console.error('❌ [migoService] Error al consultar RUC:', error);
    console.error('📊 [migoService] Error.response:', error.response);
    
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Error al consultar el RUC',
      data: null
    };
  }
};

/**
 * Consultar información de DNI desde la API de Migo
 * @param {string} dni - DNI a consultar (8 dígitos)
 * @returns {Promise<Object>} - Objeto con la información del DNI
 */
export const consultDNI = async (dni) => {
  try {
    console.log('📡 [migoService] Consultando DNI:', dni);
    
    const response = await axios.post(
      `${MIGO_API_URL}/dni`,
      {
        token: MIGO_TOKEN,
        dni: dni
      },
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('✅ [migoService] Respuesta DNI recibida:', response.data);
    console.log('📋 [migoService] Tipo de respuesta:', typeof response.data);
    console.log('📋 [migoService] Estructura completa:', JSON.stringify(response.data, null, 2));
    
    // Extraer solo los campos que necesitamos
    // La API de Migo puede devolver diferentes estructuras, intentamos todas las posibles
    const data = response.data;
    
    // Intentar extraer el nombre de todas las posibles propiedades
    let name = '';
    if (data.nombres && data.apellido_paterno && data.apellido_materno) {
      name = `${data.nombres} ${data.apellido_paterno} ${data.apellido_materno}`.trim();
    } else if (data.nombre_completo) {
      name = data.nombre_completo;
    } else if (data.nombres) {
      name = data.nombres;
    } else if (data.nombre) {
      name = data.nombre;
    }
    
    // Intentar extraer la dirección de todas las posibles propiedades
    let address = '';
    if (data.direccion) address = data.direccion;
    else if (data.direccion_completa) address = data.direccion_completa;
    else if (data.direccionCompleta) address = data.direccionCompleta;
    
    const result = {
      success: true,
      data: {
        dni: data.dni || data.numero_documento || dni,
        name: name.trim(),
        address: address.trim(),
      }
    };
    
    console.log('📤 [migoService] Datos procesados:', result);
    return result;
  } catch (error) {
    console.error('❌ [migoService] Error al consultar DNI:', error);
    console.error('📊 [migoService] Error.response:', error.response);
    
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Error al consultar el DNI',
      data: null
    };
  }
};

export const migoService = {
  consultRUC,
  consultDNI,
};

